import { ComponentVersions_3_0 } from 'constants/uxVersions'
import LoadingActionButton from 'elements/button/LoadingActionButton'
import {
  AlertTriangleOutlineIcon,
  BaseTheme,
  Button,
  ComponentVersionsInherit,
  OsButtonProps,
  styled,
} from 'opensolar-ui'
import Confirm from 'projectSections/elements/dialog/Confirm'
import { useTranslate } from 'ra-core'
import React from 'react'
import Notice from './Notice'

//Common Confirm modal using UI3 dialog format/styling
interface DialogProps {
  open: boolean
  setOpen: (open: boolean) => void
  handleSubmit: (e) => void
  handleCancel?: () => void
  title?: string
  mainText?: string
  subText?: string
  submitBtnLabel?: string
  cancelBtnLabel?: string
  submitBtnProps?: OsButtonProps
  cancelButtonProps?: OsButtonProps
  isSubmitting?: boolean
  mainIcon?: React.ReactNode | false
}
const CancelButton = styled(Button, { name: 'CancelButton' })({
  marginRight: 5,
})

const ConfirmModal: React.FC<DialogProps> = (props) => {
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <ConfirmModalContent {...props} />
    </ComponentVersionsInherit>
  )
}

const ConfirmModalContent: React.FC<DialogProps> = ({
  open,
  setOpen,
  handleSubmit,
  handleCancel,
  title = '',
  mainText = '',
  subText = '',
  submitBtnLabel = '',
  cancelBtnLabel = '',
  submitBtnProps,
  cancelButtonProps,
  isSubmitting = false,
  mainIcon,
}) => {
  const translate = useTranslate()
  if (!open) return null
  return (
    <Confirm
      ui3={true}
      header={{ title }}
      content={
        <Notice
          icon={
            mainIcon !== undefined ? (
              mainIcon
            ) : (
              <AlertTriangleOutlineIcon size={23} color={BaseTheme.palette.grey[810]} />
            )
          }
          mainText={mainText}
          subText={subText}
        />
      }
      open={open}
      buttons={[
        () => (
          <CancelButton
            key="confirm-modal-cancel-button"
            id="confirm-modal-cancel-button"
            variant="outlined"
            color="default"
            {...cancelButtonProps}
            disabled={isSubmitting || cancelButtonProps?.disabled}
            onClick={() => {
              if (isSubmitting) return
              setOpen(false)
              handleCancel?.()
            }}
          >
            {cancelBtnLabel || translate('Cancel')}
          </CancelButton>
        ),
        () => (
          <LoadingActionButton
            key="confirm-modal-accept-button"
            id="confirm-modal-accept-button"
            onClick={handleSubmit}
            {...submitBtnProps}
            aria-label={submitBtnLabel}
            loading={isSubmitting}
            disabled={submitBtnProps?.disabled}
          >
            {submitBtnLabel}
          </LoadingActionButton>
        ),
      ]}
    />
  )
}

export default ConfirmModal
